import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import {
    cancelEditCover,
    clearAllDirectFamily,
    clearAllExtendedFamily,
    clearAllParentsAndInLaws,
    saveCover,
    setSideDrawerClosed,
} from '@om/redux/actions/easiplusFuneralPlan/quote';
import {getEditCoverFormIsValid, getEditId} from '@om/redux/selectors/easiplusFuneralPlan/quote';
import {EFP_COVER_CATEGORIES} from '@om/redux/actions/easiplusFuneralPlan/types';
import {
    OmEfpAddCoverDrawer,
    OmSideDrawer,
} from '@om/component-library-react';
import OmButton from '../../../../components/forms/OmButton';
import { toggleWhatsAppBubbleWidget } from '@om/redux/middleware/rulesEngine/easiplusFuneralPlan/quote';

const QuoteSideDrawerWrapper = ({drawerIsOpen, editCategory, onClearAll, children}) => {
    const dispatch = useDispatch();
    const {editCoverIsValid, editId} = useSelector(
        createStructuredSelector({
            editId: getEditId,
            editCoverIsValid: getEditCoverFormIsValid,
        })
    );

    const addToQuote = () => {
        if (editCoverIsValid) {
            dispatch(setSideDrawerClosed());
        }

        dispatch(saveCover(editId, editCategory));
    };

    const clearAll = () => {
        if (onClearAll) {
            return onClearAll();
        }

        switch (editCategory) {
        case EFP_COVER_CATEGORIES.DIRECT_FAMILY:
            return dispatch(clearAllDirectFamily());
        case EFP_COVER_CATEGORIES.PARENTS_AND_IN_LAWS:
            return dispatch(clearAllParentsAndInLaws());
        case EFP_COVER_CATEGORIES.EXTENDED_FAMILY:
            return dispatch(clearAllExtendedFamily());
        default:
            return;
        }
    };

    return (
        <OmSideDrawer
            open={drawerIsOpen}
            onOnSideDrawerClosed={() => {
                toggleWhatsAppBubbleWidget(true);
                dispatch(cancelEditCover());
                dispatch(setSideDrawerClosed());
            }}
        >
            <div slot="side-drawer-content">
                <OmEfpAddCoverDrawer>
                    <div className="progressive-disclosure-form-wrapper">
                        {children}

                        <div className="action-buttons">
                            <OmButton
                                type="text"
                                size="small"
                                text="CLEAR ALL"
                                onClick={() => clearAll()}
                            />
                            <OmButton
                                type="primary"
                                size="small"
                                text="ADD TO QUOTE"
                                onClick={() => addToQuote()}
                            />
                        </div>
                    </div>
                </OmEfpAddCoverDrawer>
            </div>
        </OmSideDrawer>
    );
};

export default QuoteSideDrawerWrapper;
